import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardSidebar from './redesign/DashboardSidebar';
import DashboardTopbar from './redesign/DashboardTopbar';

const DashboardLayout = ({ children, onLogout, role: propRole, submissions = [], requests = [] }) => {
  const [activeTab, setActiveTab] = useState(() => localStorage.getItem('dashboardActiveTab') || 'stats');
  const [currentUser, setCurrentUser] = useState(null);
  const [role, setRole] = useState(propRole || 'viewer');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const navigate = useNavigate();
  
  useEffect(() => {
    // Get user info from localStorage
    const storedUser = localStorage.getItem('currentUser');
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setCurrentUser(userData);
        setRole(userData.role || propRole || 'viewer');
      } catch (err) {
        console.error('Error parsing user data:', err);
        handleLogout();
      }
    } else {
      handleLogout();
    }
  }, [propRole]);
  
  const handleLogout = async () => {
    try {
      let apiUrl = '/api/logout.php';
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        const port = window.location.port;
        apiUrl = `http://${window.location.hostname}${port ? ':' + port : ''}/api/logout.php`;
      }
      
      await fetch(apiUrl, { credentials: 'include' });
      
      localStorage.removeItem('currentUser');
      sessionStorage.removeItem('currentUser');
      if (onLogout) onLogout();
      navigate('/login');
    } catch (err) {
      console.error('Logout error:', err);
      localStorage.removeItem('currentUser');
      sessionStorage.removeItem('currentUser');
      if (onLogout) onLogout();
      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen bg-slate-50  text-slate-800  transition-all duration-300">
      {/* Sidebar navigation */}
      <DashboardSidebar 
        activeTab={activeTab} 
        setActiveTab={(tabId) => {
          setActiveTab(tabId);
          localStorage.setItem('dashboardActiveTab', tabId);
        }} 
        role={role} 
        collapsed={sidebarCollapsed} 
        setCollapsed={setSidebarCollapsed} 
        submissionsCount={submissions.length}
        requestsCount={requests.length}
      />

      {/* Top Header & Content Canvas */}
      <div 
        className={`transition-all duration-300 min-h-screen flex flex-col ${
          sidebarCollapsed ? 'pl-20' : 'pl-20 sm:pl-64'
        }`}
      >
        <DashboardTopbar 
          currentUser={currentUser} 
          role={role} 
          onLogout={handleLogout} 
          sidebarCollapsed={sidebarCollapsed}
        />
        
        <main className="flex-grow p-4 md:p-6 mt-16">
          {React.Children.map(children, child => {
            if (child && child.props && child.props.id === activeTab) {
              return child;
            }
            return null;
          })}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
